<template>
    <div class="row">
        <div class="col-md-12">
            <div class="tabs__content" :class="{'d-flex': !list.length || !loaded}">
                <div class="homestay knowledge-base-update knowledge-base-update-empty" v-if="!loaded">
                    <div class="homestay__profile-item knowledge-base-update__profile-item knowledge-base-update__profile-item-empty d-flex">

                        <div class="LoaderBalls">
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                            <div class="LoaderBalls__item"></div>
                        </div>

                    </div>

                </div>
                <template v-else>
                    <div class="homestay knowledge-base-update" v-if="list.length">
                        <div class="homestay__profile-item knowledge-base-update__profile-item product product--tabs-row d-flex" v-for="(item, idx) in list" :key="idx">

                            <div class="homestay__profile-left knowledge-base-update__profile-left">

                                <div class="homestay__profile-image knowledge-base-update__profile-image" v-if="item.view_mode === 'homestay'">
                                        <img :src="`/storage${item.images[0].path.replace('original', 'preview_l')}`" alt="" v-if="item.images.length">
                                        <span v-text="getUserPM(item.name)"></span>
                                </div>
                                <a class="homestay__profile-image knowledge-base-update__profile-image" :href="`/volunteer/${user.id}/profile`" v-else>
                                    <img :src="`${user.avatar.replace('original', 'avatar')}`"  alt="user" v-if="user && user.avatar">
                                    <span v-text="getUserPM(user.name)"></span>
                                </a>

                            </div>
                            <div class="homestay__profile-right knowledge-base-update__profile-right product-desc">

                                <div class="homestay__profile-title knowledge-base-update__profile-title" v-if="user && item.view_mode === 'user'" v-text="user.name"></div>
                                <div class="homestay__profile-title knowledge-base-update__profile-title" v-else v-text="item.name"></div>

                                <ul class="homestay__profile-info knowledge-base-update__profile-info">
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item" v-if="user && item.view_mode === 'user'">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Заголовок: </span>{{item.name}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Город: </span>{{item.city.name}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Адрес: </span>{{item.street_address}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Тип обьявдения: </span>{{item.view_mode === 'homestay' ? 'передержка' : 'пользователь'}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Тип передержки: </span>{{item.type === 'enclosure' ? 'вольерная' : 'квартирная'}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Прием животных: </span>{{item.reception_status === 'open' ? 'прием открыт' : 'прием закрыт'}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Тариф: </span>{{item.charge_category === 'paid_for' ? 'платно' : 'бесплатно'}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Количество дней: </span>от {{item.min_duration}} {{(item.max_duration ? `до ${item.max_duration}` : '')}}
                                    </li>
                                    <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                        <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Категории животных: </span>
                                        <span v-for="(category,idx) in item.pet_categories" :key="idx">{{category.name}}, </span>
                                    </li>

                                    <template v-if="item.images.length">
                                        <li class="homestay__profile-info-item knowledge-base-update__profile-info-item">
                                            <span class="homestay__profile-info-label knowledge-base-update__profile-info-label">Фотографии: </span>
                                            <div class="card-horizontal__user-info-photos d-flex">
                                                <a :href="`/storage${image.path}`" v-for="(image, idx) in item.images"
                                                   :data-lightbox="'transfer-' + item.id" :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>
                                            </div>
                                        </li>
                                    </template>

                                </ul>

                                <div class="homestay__profile-description knowledge-base-update__profile-description" v-text="item.description"></div>



                                <div class="knowledge-base__nav d-flex" v-if="(user) ?  (+item.user_id === +user.id) : false">
                                    <a class="btn btn-sm btn--round" :href="`/publication/homestay/${item.id}`">
                                        Редактирование
                                    </a>

                                    <a class="btn btn-sm btn--round" :style="{background: '#0674ec'}"
                                       href="#" @click.prevent="deleteItem(item.id)">
                                        Удалить
                                    </a>
                                </div>

                            </div>


                            <transition name="slide">
                                <store-form :pets="petsCategories" :updateOBJ="item" @updateForm="refreshPage" type="UPDATE" v-if="selectedItem === item.id"/>
                            </transition>



                        </div>




                    </div>

                    <div class="homestay knowledge-base-update knowledge-base-update-empty"  v-else>
                        <div class="homestay__profile-item knowledge-base-update__profile-item knowledge-base-update__profile-item-empty d-flex">

                            Список пуст.

                        </div>
                    </div>





                </template>


            </div>
        </div>

        <div class="col-md-12" v-if="pageCount > 1">
            <div class="pagination-area">
                <nav class="navigation pagination" role="navigation">
                    <div class="nav-links">
                        <paginate
                            v-model="page"
                            :page-count="pageCount"
                            :click-handler="paginateClickCallback"
                            :prev-text="''"
                            :next-text="''"
                            :container-class="'className'"
                            :page-class="'page-numbers'"
                            :page-link-class="''"
                            :active-class="'current'"
                            :prev-class="'prev page-numbers'"
                            :prev-link-class="'lnr lnr-arrow-left'"
                            :next-class="'next page-numbers'"
                            :next-link-class="'lnr lnr-arrow-right'"
                        >
                        </paginate>
                    </div>
                </nav>
            </div>
        </div>

    </div>
</template>

<script>

import StoreForm from "../../../Homestays/StoreForm";

export default {
    name: "TabHomestays",
    components:{
        StoreForm
    },
    data(){
        return{
            list: [],
            pageCount: 0,
            page: 1,
            selectedItem: null,
            loaded: true,

            petsCategories: []
        }
    },

    mounted(){
        this.loaded = false
        this.getMyHomestays()

        this.getPetsCategories()
    },


    watch:{
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        }
    },
    computed:{

        user(){
            return this.$store.getters.getUserData;
        }

    },
    methods:{

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;
            this.getMyHomestays();
        },

        getPetsCategories(){
            let url = '/api/pets/categories'

            axios.get(url)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.petsCategories = response.data
                    }

                })
                .catch(error => {
                    error = error.response.data
                    console.log(error)
                })
        },
        refreshPage(){
          this.getMyHomestays()
        },

        deleteItem(idx){
            let  url = `/api/homestays/${idx}`

            axios.delete(url)
                .then(response => {
                    response = response.data

                    if(response.succes){

                        console.log('deleted')

                    }

                })
                .catch(error => {
                    error = error.response.data

                    console.log(error)

                })
                .then(() => {
                    this.getMyHomestays()
                })

        },

        getMyHomestays(){
            let url = `/api/my-homestays`

            axios.get(url,{
                params: {
                    page: this.page,
                    per_page: 5,
                }
            })
                .then((response) => {

                    response = response.data

                    if(response.success){
                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page
                    }

                })
                .catch((error) => {
                    error = error.response.data
                    console.log(error)
                })


        },

        openForm(idx){

            if(this.selectedItem === idx) return this.selectedItem = null

            return this.selectedItem = idx
        }


    },




}
</script>

<style lang="scss" scoped>

.slide-enter-active {
    -moz-transition-duration: 0.4s;
    -webkit-transition-duration: 0.4s;
    -o-transition-duration: 0.4s;
    transition-duration: 0.4s;
    -moz-transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -o-transition-timing-function: ease;
    transition-timing-function: ease;
}

.slide-leave-active {
    -moz-transition-duration: 0.4s;
    -webkit-transition-duration: 0.4s;
    -o-transition-duration: 0.4s;
    transition-duration: 0.4s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
    max-height: 1000px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}


</style>
